import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
} from '@/api/potentialvehicleinfoserv'

export default {
  state: {
    state_PotentialVehicleInfo_AddObjResult: null,
    state_PotentialVehicleInfo_GetAllResult: null,
    state_PotentialVehicleInfo_GetPageResult: null,
    state_PotentialVehicleInfo_GetDetailResult: null,
    state_PotentialVehicleInfo_ModifyObjResult: null,
    state_PotentialVehicleInfo_DeleteObjResult: null,
  },
  mutations: {
    SET_POTENTIALVEHICLEINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_PotentialVehicleInfo_AddObjResult = rst;
    },
    SET_POTENTIALVEHICLEINFO_GETALL_RESULT: (state, rst) => {
      state.state_PotentialVehicleInfo_GetAllResult = rst;
    },
    SET_POTENTIALVEHICLEINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_PotentialVehicleInfo_GetPageResult = rst;
    },
    SET_POTENTIALVEHICLEINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_PotentialVehicleInfo_GetDetailResult = rst;
    },
    SET_POTENTIALVEHICLEINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_PotentialVehicleInfo_ModifyObjResult = rst;
    },
    SET_POTENTIALVEHICLEINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_PotentialVehicleInfo_DeleteObjResult = rst;
    },
  },
  actions: {
    PotentialVehicleInfoServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POTENTIALVEHICLEINFO_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POTENTIALVEHICLEINFO_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PotentialVehicleInfoServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POTENTIALVEHICLEINFO_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POTENTIALVEHICLEINFO_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PotentialVehicleInfoServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POTENTIALVEHICLEINFO_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POTENTIALVEHICLEINFO_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PotentialVehicleInfoServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POTENTIALVEHICLEINFO_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POTENTIALVEHICLEINFO_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PotentialVehicleInfoServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POTENTIALVEHICLEINFO_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POTENTIALVEHICLEINFO_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PotentialVehicleInfoServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POTENTIALVEHICLEINFO_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POTENTIALVEHICLEINFO_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_PotentialVehicleInfo_AddObjResult: state => {
      return state.state_PotentialVehicleInfo_AddObjResult;
    },
    get_PotentialVehicleInfo_GetAllResult: state => {
      return state.state_PotentialVehicleInfo_GetAllResult;
    },
    get_PotentialVehicleInfo_GetPageResult: state => {
      return state.state_PotentialVehicleInfo_GetPageResult;
    },
    get_PotentialVehicleInfo_GetDetailResult: state => {
      return state.state_PotentialVehicleInfo_GetDetailResult;
    },
    get_PotentialVehicleInfo_ModifyObjResult: state => {
      return state.state_PotentialVehicleInfo_ModifyObjResult;
    },
    get_PotentialVehicleInfo_DeleteObjResult: state => {
      return state.state_PotentialVehicleInfo_DeleteObjResult;
    },
  }
}